import request from "./request";
import apis from "./apis";

const {
  allSaleGroupInfo,
  saleGroupInfo,
  allSaleProductInfo,
  saleProductInfo,
  purchase,
  balanceInfo,
  saleHistory,
  exportSaleHistory,
  saleSubjectInfo,
} = apis.sale;

const sale = {
  getSaleGroupInfo: () => {
    return request.get(allSaleGroupInfo);
  },
  createSaleGroupInfo: (data: Object) => {
    return request.post(saleGroupInfo, data);
  },
  updateSaleGroupInfo: (data: Object) => {
    return request.put(saleGroupInfo, data);
  },
  deleteSaleGroupInfo: (data: Object) => {
    return request.delete(saleGroupInfo, data);
  },
  getSaleProductInfo: (data: Object) => {
    return request.get(allSaleProductInfo, data);
  },
  createSaleProductInfo: (data: Object) => {
    return request.post(saleProductInfo, data);
  },
  updateSaleProductInfo: (data: Object) => {
    return request.put(saleProductInfo, data);
  },
  deleteSaleProductInfo: (data: Object) => {
    return request.delete(saleProductInfo, data);
  },
  purchase: (data: Object) => {
    return request.post(purchase, data);
  },
  getBalanceInfo: (data: Object) => {
    return request.get(balanceInfo, data);
  },
  getSaleHistory: (data: Object) => {
    return request.get(saleHistory, data);
  },
  exportSaleHistory: (data: Object) => {
    return request.get(exportSaleHistory, data);
  },
  getAllSaleSubjectInfo: () => {
    return request.get(saleSubjectInfo);
  },
  createSaleSubjectInfo: (data: Object) => {
    return request.post(saleSubjectInfo, data);
  },
  updateSaleSubjectInfo: (data: Object) => {
    return request.put(saleSubjectInfo, data);
  },
  deleteSaleSubjectInfo: (data: Object) => {
    return request.delete(saleSubjectInfo, data);
  },
  getAllUserBalance: () => {
    return request.get(apis.sale.allUserBalance);
  }
};

export default sale;